import React, { useCallback, useEffect, useRef } from 'react';
import { useAppSelector } from 'store/hooks';
import { EditDeleteModal } from 'design-system';
import { IconGoal } from 'design-system/icons';
import SavingsProgress from 'design-system/SavingsProgress';
import UpgradeCard from 'design-system/UpgradeCard';
import { muteAll, useFetchOld } from 'hooks';
import useShouldShowUpgrade from 'features/premium/hooks/useShouldShowUpgrade';
import { DEFAULT_DELAY_TIME } from 'utils/delay';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { updatePot } from '../actions';
import { showDeletedPotAlert } from '../utils';
const PotGoalSection = ({ pot }) => {
    const navigation = useMainStackNavigation();
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const [, , , fetch] = useFetchOld(muteAll);
    const timeout = useRef(undefined);
    const handleEdit = useCallback(() => {
        EditDeleteModal.hide();
        timeout.current = setTimeout(() => {
            navigation.navigateDeprecated('EditPotGoal', { pot });
        }, DEFAULT_DELAY_TIME);
    }, [pot]);
    useEffect(() => () => {
        clearTimeout(timeout.current);
    }, []);
    const handleDelete = useCallback(async () => {
        try {
            const response = await fetch(updatePot({ ...pot, goal: undefined }));
            if (response?.pot) {
                navigation.setParams({ screenParams: { ...pot, goal: undefined } });
            }
        }
        catch {
            // no need to show anything, the error middleware already did
        }
    }, [pot]);
    const handlePress = useCallback(() => {
        if (pot.deletedAt) {
            showDeletedPotAlert();
            return;
        }
        EditDeleteModal.show({
            onEdit: handleEdit,
            onDelete: handleDelete,
        });
    }, [handleDelete, handleEdit, pot.deletedAt]);
    const { goal } = pot;
    const { isUnlocked, onPressUpgrade } = useShouldShowUpgrade({ benefitId: 'savingGoals' });
    if (!goal)
        return null;
    if (!isUnlocked) {
        return (<UpgradeCard icon={<IconGoal />} title="Continue tracking your goal" description="Upgrade your plan to see and edit your saving goals" noMarginBottom onPressUpgrade={onPressUpgrade}/>);
    }
    return (<TouchableBounceCard withPadding noMarginBottom noMarginTop onDark onPress={handlePress}>
      <SavingsProgress currency={pot.balance.currency} balance={pot.balance.value} goalAmount={goal.amount} endDate={goal.date} scrambled={scrambled}/>
    </TouchableBounceCard>);
};
export default PotGoalSection;
